import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { SignupService } from '../auth/services/signup.service';

@Injectable({
  providedIn: 'root',
})
export class AccountNameValidator implements AsyncValidator {
  constructor(private signupService: SignupService) {}
  validate = (control: AbstractControl) => {
    const { value } = control;
    const error: ValidationErrors = { duplicateName: true };
    return this.signupService.checkAccountExist(value).pipe(
      take(1),
      map((response) => {
        return response.Exists ? error : null;
      }),
      catchError((err) => {
        return of(err);
      })
    );
  };
}
